import { createApp } from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'

import vClickOutside from 'click-outside-vue3'

import { Inkline, components } from '@inkline/inkline'
import '@inkline/inkline/inkline.scss'

import './main.scss'

createApp(App)
  .use(router)
  .use(store)
  .use(vClickOutside)
  .use(Inkline, { components })
  .mount('#app')
